import { InternalServerError } from './errors';
import {
  HttpApiEndpoint,
  HttpApiGroup,
  HttpApiSchema,
  OpenApi,
} from 'effect/unstable/httpapi';
// Canonical response schema, derived from VOICE_DEFS (the single source of
// truth) rather than the staging-generated snapshot — see ./schemas/voice.
import { GetListVoices200 } from './schemas/voice';

const listVoicesEndpoint = HttpApiEndpoint.get('ListVoices', '/voices', {
  success: GetListVoices200.pipe(HttpApiSchema.status(200)),
  error: InternalServerError,
})
  .annotate(OpenApi.Summary, 'List Available Voices')
  .annotate(
    OpenApi.Description,
    'Get all available voices for text-to-speech synthesis.',
  );

export const voicesGroup = HttpApiGroup.make('Voices')
  .add(listVoicesEndpoint)
  .prefix('/v2');
